import React, { useState } from "react";
import Logo from "../common/mobile/Logo";


const Footer = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const origin = window.location.origin.replace(/^https?:\/\/(www\.)?/, '').replace(/(\.com|\.live|\.net)$/i, '');



  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  return (
    <div className="footer-wrap">
      <div className="footer-1200">
       

        <ul className="footer-link-group">
          {/* Footer Links */}
          <li>
            <div className="icon-wrap icon1"></div>
            <div className="text-wrap">
              <h4>Customer Support</h4>
              <h5>Available 24/7 to assist you</h5>
            </div>
          </li>
          <li>
            <div className="icon-wrap icon2"></div>
            <div className="text-wrap">
              <h4>New Member Guide</h4>
              <h5>Check out FAQ and guides</h5>
              <a href="https://{origin}help.com/">Explore Now</a>
            </div>
          </li>
          <li>
            <div className="icon-wrap icon3"></div>
            <div className="text-wrap">
              <h4>Brand Ambassador</h4>
              <h5>Play with celebrity</h5>
              <a href="#" data-pagetype="43">Have Fun Now</a>
            </div>
          </li>
          <li className="android-img">
            <a href="/page/site/component/appDownload.jsp" target="_blank">
              <img src="https://www.{origin}.com/images/web/footer/android-en.png" alt="Download for Android" />
            </a>
          </li>
        </ul>

        <ul className="footer-partner-wrap">
          {/* Responsible Gaming */}
          <li className="duty">
            <h5>Responsible Gaming</h5>
            <a href="https://www.gamcare.org.uk/" target="_blank" rel="noopener noreferrer">
              <img src="https://www.{origin}.com/images/web/footer/color-white/safe1.png" alt="GamCare" />
            </a>
            <a href="https://{origin}help.com/account/18-policy/" target="_blank" rel="noopener noreferrer">
              <img src="https://www.{origin}.com/images/web/footer/color-white/safe2.png" alt="18+ Policy" />
            </a>
            <a href="https://{origin}help.com/responsible-gaming/" target="_blank" rel="noopener noreferrer">
              <img src="https://www.{origin}.com/images/web/footer/color-white/safe3.png" alt="Responsible Gaming" />
            </a>
          </li>
          
          {/* Payment Methods */}
          <li className="payment">
            <h5>Payment Methods</h5>
            {/* Add payment icons here */}
            <a href="#"><img src="https://www.{origin}.com/images/web/footer/color-white/pay16.png" alt="Bank Deposit" /></a>
            <a href="#"><img src="https://www.{origin}.com/images/web/footer/color-white/pay22.png" alt="bKash" /></a>
            <a href="#"><img src="https://www.{origin}.com/images/web/footer/color-white/pay33.png" /></a>
            <a href="#"><img src="https://www.{origin}.com/images/web/footer/color-white/pay34.png" /></a>
            <a href="#"><img src="https://www.{origin}.com/images/web/footer/color-white/pay45.png" alt="UPAY" /></a>
            <a href="#"><img src="https://www.{origin}.com/images/web/footer/color-white/pay59.png" alt="OKWallet" /></a>
            <a href="#"><img src="https://www.{origin}.com/images/web/footer/color-white/pay60.png" alt="SureCash" /></a>
            <a href="#"><img src="https://www.{origin}.com/images/web/footer/color-white/pay61.png" alt="tapPay" /></a>
            <a href="#"><img src="https://www.{origin}.com/images/web/footer/color-white/pay47.png" alt="USDT" /></a>
            <a href="#"><img src="https://www.{origin}.com/images/web/footer/color-white/pay91.png" alt="BTC" /></a>
          </li>

          {/* Social Media */}
          <li className="social-media">
            <h5>Community Websites</h5>
            <a href="https://cutt.ly/X8zvJCK" target="_blank" rel="noopener noreferrer">
              <img src="https://www.{origin}.com/images/web/footer/color-white/FaceBook.png" alt="Facebook" />
            </a>
            <a href="https://cutt.ly/F8zWryo" target="_blank" rel="noopener noreferrer">
              <img src="https://www.{origin}.com/images/web/footer/color-white/Instagram.png" alt="Instagram" />
            </a>
            <a href="https://cutt.ly/V8zQ3in" target="_blank" rel="noopener noreferrer">
              <img src="https://www.{origin}.com/images/web/footer/color-white/Twitter.png" alt="Twitter" />
            </a>
            <a href="https://cutt.ly/n8zWnUX" target="_blank" rel="noopener noreferrer">
              <img src="https://www.{origin}.com/images/web/footer/color-white/Pinterest.png" alt="Pinterest" />
            </a>
            <a href="https://cutt.ly/A8zWKKF" target="_blank" rel="noopener noreferrer">
              <img src="https://www.{origin}.com/images/web/footer/color-white/Youtube.png" alt="YouTube" />
            </a>
            <a href="https://cutt.ly/Dwkk45sZ" target="_blank" rel="noopener noreferrer">
              <img src="https://www.{origin}.com/images/web/footer/color-white/Telegram.png" alt="Telegram" />
            </a>
          </li>

          {/* Sponsorship and Ambassadors */}
          <li className="ft-spon">
            <h5>Sponsorships</h5>
            <div className="ft-spon__icon">
              <img className="spon-icon" src="https://www.{origin}.com/images/web/sponsor/delhi-bulls.png" alt="Delhi Bulls Sponsor" />
              <p>Delhi Bulls<br />2023 - 2024<span>Title Sponsor</span></p>
            </div>
          </li>
          
          <li className="ft-ambassador">
            <h5>Brand Ambassadors</h5>
            <ul className="header-btn-wrap">
              <li>
                <img src="https://www.{origin}.com/images/v1/web/jb/footer/ambassador_signature/andre-russell.png" alt="Andre Russell" />
                <a href="#" data-pagetype="43" data-active="andre-russell">
                  Andre Dwayne Russell<br />2024 - 2026
                </a>
              </li>
              <li>
                <img src="https://www.{origin}.com/images/v1/web/jb/footer/ambassador_signature/mcgrath.png" alt="Glenn McGrath" />
                <a href="#" data-pagetype="43" data-active="glenn-mcgrath">
                  Glenn McGrath<br />2023 - 2024
                </a>
              </li>
            </ul>
          </li>

          {/* Gaming License */}
          <li className="gaming-license">
            <h5>Gaming License</h5>
            <img src="https://www.{origin}.com/images/web/footer/gaming_license.png" alt="Gaming License" />
          </li>
        </ul>

        {/* Footer License and Logo */}
        <div className="footer-license">
          <div className="license-cont"></div>
        </div>
        
        <div className="footer-logo-wrap">
          <div className="footer-logo">
            <Logo/>
          </div>
          <div className="link-wrap">
            <ul>
              <li><a href="/" target="_blank" rel="noopener noreferrer">Affiliate</a></li>
              <li><a href="#" data-pagetype="25">Responsible Gaming</a></li>
              <li><a href="#" data-pagetype="21">About Us</a></li>
            </ul>
            <p>© 2024 {origin} Copyrights. All Rights Reserved</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;